import React, { useEffect } from 'react';
import Dashboard from './components/Dashboard';

function App() {
  useEffect(() => {
    const handleNumberInputWheel = (event) => {
      const target = event.target;
      if (
        target instanceof HTMLInputElement &&
        target.type === 'number' &&
        document.activeElement === target
      ) {
        target.blur();
      }
    };

    window.addEventListener('wheel', handleNumberInputWheel, { capture: true });
    return () => {
      window.removeEventListener('wheel', handleNumberInputWheel, { capture: true });
    };
  }, []);

  return (
    <div className="App">
      <Dashboard />
    </div>
  );
}

export default App;
